import { getPointInfo, PointInfo } from '@/app/actions/user';
import { useAuth } from '@/providers/auth-provider';
import { useCallback, useState } from 'react';
import { toast } from 'sonner';

const EMPTY_POINT_INFO: PointInfo = {
  task_estimated_point_deep_research: 0,
  task_count_deep_research: 0,
  available: 0,
  accumulated: 0,
  membership: false,
  membership_expire_time: '',
  got_free_week_membership: false,
  total_running_task_estimated_point_deep_research: 0,
  free_week_membership_expired: false,
  can_activate_card: true,
  tier_rank: null,
  tier_name: null,
  product_id: null,
  sku_id: null,
  point_amount: null,
  point_amount_per_month: null,
  daily_sign_in_points: null,
};

export const usePointInfo = (): {
  info: PointInfo;
  getInfo: () => Promise<PointInfo | undefined>;
} => {
  const { user } = useAuth();
  const [info, setInfo] = useState<PointInfo | null>(null);

  const getInfo = useCallback(async () => {
    try {
      const res = await getPointInfo();
      setInfo(res);
      return res;
    } catch {
      toast.error('获取积分信息失败', {
        position: 'top-center',
      });
    }
  }, []);

  return { info: info ?? user?.pointInfo ?? EMPTY_POINT_INFO, getInfo };
};
